import AsyncStorage from '@react-native-community/async-storage';
import * as ActionTypes from './../constants';
import axios from 'axios'; 
import {baseUrl } from './index';

const dispatchRequestExams = () => ({
    type: ActionTypes.REQUEST_EXAMS
})

const dispatchReceivedExams = exams => ({
    type: ActionTypes.RECEIVED_EXAMS,
    exams
})

export const dispatchClearExams = () => ({
    type: ActionTypes.CLEAR_EXAMS
})
const dispatchErrorExams = (err) => ({
    type: ActionTypes.ERROR_EXAMS,
    err
})

export function getExams() {
    return dispatch => {
        dispatch(dispatchRequestExams());
        AsyncStorage.getItem('authKey', (err, res) => {
            if(err) return console.log(err, 'get exams auth error');
           
            const options = {
                method: 'post',
                url: `${baseUrl}/api/exams`,
                headers: {
                    'Authorization': `Bearer ${res}`
                }
            }
            // console.log(options, 'get exams options');

            axios(options)
                .then(({data}) => {
                    // console.log(data, 'exams data');
                    dispatch(dispatchReceivedExams(data));
                })
                .catch(e => dispatch(dispatchErrorExams(e)))
        })
    }
}